/* tslint:disable */
/* eslint-disable */
export enum WorkUserPublicJoblevelEnum {
  Bereichsleitung = 'BEREICHSLEITUNG',
  Abteilungsleitung = 'ABTEILUNGSLEITUNG',
  Teamleitung = 'TEAMLEITUNG',
  Mitarbeitende = 'MITARBEITENDE'
}
